import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import { createTransition } from '../utilities/create-transition.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Label } from '@vebox/etui-system-elements';

const _excluded = ["left", "startInputAddon", "endInputAddon", "shouldFloat", "theme", "disabled", "size"];
const InputLabel = styled(Label).attrs(_ref => {
  let {
      left,
      startInputAddon,
      endInputAddon,
      shouldFloat,
      theme,
      disabled,
      size
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({
    position: 'absolute'
  }, theme.typography.label), {}, {
    color: theme.palette.text.secondary,
    fontSize: shouldFloat ? theme.typography.fontSizeSmall : theme.typography.fontSizeBase,
    pr: endInputAddon ? '48px' : '16px',
    pl: left || startInputAddon ? `calc(${theme.spacing.xs + 24 + theme.spacing.xs}px + 1px)` : 0,
    transform: shouldFloat && startInputAddon ? `translate(0, ${size === 'default' ? theme.spacing.xs : theme.spacing.xxs}px) scale(1)` : shouldFloat && !startInputAddon ? `translate(8px, ${size === 'default' ? theme.spacing.xs : theme.spacing.xxs}px) scale(1)` : startInputAddon ? `translate(0, ${size === 'default' ? '14px' : '10px'}) scale(1)` : `translate(8px, ${size === 'default' ? '14px' : '10px'}) scale(1)`,
    opacity: disabled ? theme.palette.action.disabledOpacity : 1,
    left: 0,
    right: 0,
    width: '100%',
    transition: createTransition(['color', 'transform', 'font-size'], {
      duration: 'shorter',
      easing: 'easeOut'
    })
  }, props);
})`
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const _excluded$1 = ["size"];
function InputLabel$1(_ref) {
  let {
      size = 'default'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/createElement(InputLabel, _extends({
    size: size
  }, props));
}

export default InputLabel$1;
